export const ControlIssue = {
    path: '/control_issues',
    name: 'control_issues',
    component: () => import('@/views/Notification/ControlIssue/ControlIssues.vue'),
    children: [
        // Parent
        {
            path: '/control_issues/parent/module/:module/add',
            name: 'control_issues.parent.add',
            component: () => import('@/views/Notification/ControlIssue/Form/ParentControlIssueForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/control_issues/parent/module/:module/edit/:id',
            name: 'control_issues.parent.edit',
            component: () => import('@/views/Notification/ControlIssue/Form/ParentControlIssueForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/control_issues/parent/module/:module/delete/:id',
            name: 'control_issues.parent.delete',
            component: () => import('@/views/Notification/ControlIssue/Form/ParentControlIssueForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/control_issues/parent/module/:module/view/:id',
            name: 'control_issues.parent.view',
            component: () => import('@/views/Notification/ControlIssue/Form/ParentControlIssueForm.vue'),
            props: {viewAction: true}
        },
        // Child
        {
            path: '/control_issues/child/module/:module/add',
            name: 'control_issues.child.add',
            component: () => import('@/views/Notification/ControlIssue/Form/ChildControlIssueForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/control_issues/child/module/:module/edit/:id',
            name: 'control_issues.child.edit',
            component: () => import('@/views/Notification/ControlIssue/Form/ChildControlIssueForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/control_issues/child/module/:module/delete/:id',
            name: 'control_issues.child.delete',
            component: () => import('@/views/Notification/ControlIssue/Form/ChildControlIssueForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/control_issues/child/module/:module/view/:id',
            name: 'control_issues.child.view',
            component: () => import('@/views/Notification/ControlIssue/Form/ChildControlIssueForm.vue'),
            props: {viewAction: true}
        },
    ],
}